@for (item of items; track item) {
  <span
    class="box-border overflow-hidden relative inline-block will-change-transform bg-slate-200"
    [ngClass]="loaderModifierClasses"
    [ngStyle]="theme"
  >
  </span>
}
